export * from './baPageTop.component';



// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/theme/components/baPageTop/index.ts